import moment from 'moment'
import React, { useMemo } from 'react'
import { Practitioner } from '@customTypes/Practitioner'
import { WithRequired } from '@customTypes/Util'
import { useIsTabletPortraitUp } from 'src/config/mediaQueries'
import CardsLayout from '@components/CardsLayout'
import PractitionerCard from './PractitionerCard'
import { SelectAll } from './SelectAll/SelectAll'
import useStyles from './Body.styles'
interface Props {
  selected: string[]
  clickHandler: (id: string) => void
  practitioners: Practitioner[]
  handleToggleSelectAll: () => void
  allPractitionersSelected: boolean
}

const asNumber = (date: string | undefined) => (date ? moment(date).valueOf() : Number.MAX_VALUE)

const Body = ({ selected, clickHandler, practitioners, allPractitionersSelected, handleToggleSelectAll }: Props) => {
  const classes = useStyles()
  const sortedPractitioners = useMemo(
    () =>
      practitioners
        .filter((practitioner) => practitioner.name && practitioner.referenceId)
        .sort((a, b) => asNumber(a.nextAvailable) - asNumber(b.nextAvailable)),
    [practitioners]
  ) as WithRequired<WithRequired<Practitioner, 'name'>, 'referenceId'>[]

  const isTabletPortraitUp = useIsTabletPortraitUp()

  return (
    <div className={classes.body}>
      <SelectAll handleToggleSelectAll={handleToggleSelectAll} allPractitionersSelected={allPractitionersSelected} />

      <CardsLayout
        isDesktop={isTabletPortraitUp}
        className={classes.cardsLayoutOverride}
        noPadding
        noGap
        containerClassName={classes.cardsLayoutContainerOverride}
      >
        {sortedPractitioners.map(
          ({
            referenceId,
            name,
            imageUrl,
            languages,
            nextAvailable,
            rating,
            positions,
            gender,
            displayRole,
            specialisations,
          }) => {
            const isSelected = selected.some((id) => id === referenceId)

            return (
              <PractitionerCard
                key={referenceId}
                isDesktop={isTabletPortraitUp}
                isSelected={isSelected}
                name={name}
                gender={gender}
                rating={rating}
                positions={positions}
                imageUrl={imageUrl}
                languages={languages}
                nextAvailable={nextAvailable}
                onClick={() => clickHandler(referenceId)}
                displayRole={displayRole}
                specialisations={specialisations || []}
              />
            )
          }
        )}
      </CardsLayout>
    </div>
  )
}

export default Body
